import { 
  FaCode, 
  FaMobileAlt, 
  FaPalette, 
  FaCloud, 
  FaBrain, 
  FaCogs, 
  FaChartLine, 
  FaUsers 
} from 'react-icons/fa';

export const servicesData = {
  /* ======================================================
     GERMAN
  ====================================================== */
  de: {
    sections: [
      {
        id: "traditional-services",
        title: "Traditionelle Dienstleistungen",
        services: [
          {
            id: "web-development",
            title: "Web-Entwicklung",
            icon: FaCode,
            groups: [
              {
                title: "Traditionelle Web-Entwicklung",
                text:
                  "Wir entwickeln responsive Web-Applikationen, die auf allen Geräten und Bildschirmgrößen zuverlässig funktionieren. Unsere Lösungen umfassen leistungsfähige Online-Managementsysteme zur Optimierung von Geschäftsprozessen sowie Echtzeit-Datenverarbeitung für fundierte und schnelle Entscheidungen. Intelligente Suchfunktionen sorgen für eine verbesserte Benutzererfahrung und effizienten Informationszugang.",
              },
              {
                title: "Erweiterte Features",
                text:
                  "Zusätzlich zur klassischen Web-Entwicklung integrieren wir moderne Content-Management-Systeme für eine einfache Pflege von Inhalten. Wir realisieren skalierbare E-Commerce-Lösungen, binden externe Systeme nahtlos über APIs an und optimieren die Performance Ihrer Anwendungen für kurze Ladezeiten, Stabilität und langfristige Skalierbarkeit.",
              },
            ],
          },
          {
            id: "mobile-development",
            title: "Mobile-Entwicklung",
            icon: FaMobileAlt,
            groups: [
              {
                title: "Mobile Apps",
                text:
                  "Wir konzipieren und entwickeln leistungsstarke Mobile Apps für iOS und Android. Abhängig von den Anforderungen setzen wir auf native, plattformübergreifende oder hybride Ansätze, um maximale Reichweite, optimale Performance und eine effiziente Umsetzung zu gewährleisten.",
              },
              {
                title: "Mobile Features",
                text:
                  "Unsere mobilen Anwendungen bieten umfangreiche Funktionen wie Push-Benachrichtigungen zur Steigerung der Nutzerbindung, Offline-Funktionalitäten für eine unabhängige Nutzung sowie GPS-Integration für standortbasierte Services und die Anbindung an externe Plattformen.",
              },
            ],
          },
          {
            id: "ui-ux",
            title: "UI/UX Design",
            icon: FaPalette,
            groups: [
              {
                title: "Design aus Nutzersicht",
                text:
                  "Unser UI/UX-Design folgt einer nutzerzentrierten Herangehensweise. Durch gezielte Analyse und Forschung gewinnen wir ein tiefes Verständnis für Nutzerbedürfnisse und entwickeln darauf aufbauend klare Strukturen, intuitive Navigation und moderne Benutzeroberflächen.",
              },
              {
                title: "Design-Features",
                text:
                  "Wir gestalten responsive Interfaces für alle Endgeräte, setzen barrierefreie Designstandards um und sorgen für eine konsistente Integration Ihrer Markenidentität über alle digitalen Touchpoints hinweg.",
              },
            ],
          },
          {
            id: "cloud",
            title: "Cloud Computing",
            icon: FaCloud,
            groups: [
              {
                title: "Cloud-Migration",
                text:
                  "Wir begleiten Unternehmen bei der Migration in die Cloud und realisieren Lösungen auf Basis von Infrastructure as a Service (IaaS), Platform as a Service (PaaS) und Software as a Service (SaaS). Dabei schaffen wir flexible und zukunftssichere Cloud-Infrastrukturen.",
              },
              {
                title: "Cloud-Features",
                text:
                  "Unsere Cloud-Lösungen bieten skalierbare Ressourcen, automatische Backups zur Datensicherheit, Multi-Cloud-Strategien für hohe Verfügbarkeit sowie moderne Sicherheitskonzepte zum Schutz sensibler Daten und Systeme.",
              },
            ],
          },
        ],
      },

      {
        id: "ai-solutions",
        title: "Neue KI-Lösungen",
        services: [
          {
            id: "ai-solutions",
            title: "KI-Lösungen",
            icon: FaBrain,
            groups: [
              {
                title: "Software-Lösungen powered by AI",
                text:
                  "Wir entwickeln intelligente Softwarelösungen auf Basis künstlicher Intelligenz, die Geschäftsprozesse automatisieren und optimieren. Dazu zählen Machine-Learning-Modelle für prädiktive Analysen, Natural Language Processing für intelligente Interaktionen sowie Computer-Vision-Technologien zur Bild- und Videoanalyse.",
              },
              {
                title: "AI-Software-Features",
                text:
                  "Unsere KI-Lösungen werden individuell auf Ihre Geschäftsanforderungen zugeschnitten. Sie lassen sich nahtlos über APIs integrieren, verarbeiten Daten nahezu in Echtzeit und basieren auf skalierbaren Architekturen, die mit Ihrem Unternehmen mitwachsen.",
              },
            ],
          },
          {
            id: "process-optimization-ai",
            title: "Prozessoptimierung powered by AI",
            icon: FaCogs,
            groups: [
              {
                title: "Workflow-Optimierung",
                text:
                  "Durch den Einsatz von KI analysieren wir bestehende Workflows automatisch und identifizieren Optimierungspotenziale. Intelligente Prozessautomatisierung, prädiktive Analysen und kontinuierliches Monitoring ermöglichen nachhaltige Effizienzsteigerungen.",
              },
              {
                title: "Optimierungs-Features",
                text:
                  "Unsere Lösungen erkennen Engpässe frühzeitig, optimieren Ressourcennutzung und liefern aussagekräftige Performance-Analysen. Automatisierte Reports sorgen für Transparenz und datenbasierte Entscheidungsgrundlagen.",
              },
            ],
          },
          {
            id: "data-visualization-ai",
            title: "Data Visualization using Embedded AI",
            icon: FaChartLine,
            groups: [
              {
                title: "Datenvisualisierung mit Embedded AI",
                text:
                  "Wir entwickeln intelligente Visualisierungslösungen, die Daten automatisch analysieren und verständlich darstellen. Dashboards werden dynamisch auf Basis von Datenmustern erstellt und liefern aussagekräftige Insights nahezu in Echtzeit.",
              },
              {
                title: "Visualization Features",
                text:
                  "Unsere Visualisierungslösungen ermöglichen natürliche Sprachabfragen, automatische Anomalie-Erkennung sowie intelligente Drill-Down-Funktionen. Personalisierte Dashboards passen sich dem Nutzerverhalten an.",
              },
            ],
          },
        ],
      },

      {
        id: "consultation",
        title: "Neue Beratungsdienstleistungen",
        services: [
          {
            id: "consultation-services",
            title: "Beratungsdienstleistungen",
            icon: FaUsers,
            groups: [
              {
                title: "Gap-Identifikation",
                text:
                  "Wir bieten spezialisierte Beratungsleistungen zur Identifikation von Lücken in bestehenden Geschäftsprozessen und Systemen. Durch systematische Analysen, Benchmarking und messbare Effizienzbewertungen identifizieren wir konkrete Optimierungspotenziale.",
              },
              {
                title: "Projektmanagement",
                text:
                  "Unsere Projektmanagement-Services gewährleisten strukturierte Planung, effiziente Ressourcenzuweisung und realistische Zeitpläne. Durch agile Methoden und proaktives Risikomanagement setzen wir Projekte transparent und erfolgreich um.",
              },
              {
                title: "Effizienzoptimierung",
                text:
                  "Durch tiefgehendes Prozessverständnis und gezielte Gap-Analyse unterstützen wir Unternehmen bei der Optimierung von Workflows, der Reduzierung von Kosten und der nachhaltigen Steigerung der Gesamteffizienz.",
              },
            ],
          },
        ],
      },
    ],
  },

  /* ======================================================
     ENGLISH
  ====================================================== */
  en: {
    sections: [
      {
        id: "traditional-services",
        title: "Traditional Services",
        services: [
          {
            id: "web-development",
            title: "Web Development",
            icon: FaCode,
            groups: [
              {
                title: "Traditional Web Development",
                text:
                  "We design and develop responsive web applications that perform reliably across all devices and screen sizes. Our solutions include robust online management systems that optimize business processes, as well as near real-time data processing to support fast and informed decision-making. Intelligent search functionality enhances usability and accessibility.",
              },
              {
                title: "Enhanced Features",
                text:
                  "In addition to traditional development, we implement modern content management systems for easy content administration. We deliver scalable e-commerce solutions, integrate external systems via APIs, and optimize performance for speed, stability, and long-term scalability.",
              },
            ],
          },
          {
            id: "mobile-development",
            title: "Mobile Development",
            icon: FaMobileAlt,
            groups: [
              {
                title: "Mobile Apps",
                text:
                  "We design and develop high-performance mobile applications for iOS and Android. Depending on project requirements, we use native, cross-platform, or hybrid approaches to ensure maximum reach, optimal performance, and efficient delivery.",
              },
              {
                title: "Mobile Features",
                text:
                  "Our mobile applications include push notifications to increase engagement, offline functionality for uninterrupted usage, GPS integration for location-based services, and seamless connectivity with external platforms.",
              },
            ],
          },
          {
            id: "ui-ux",
            title: "UI/UX Design",
            icon: FaPalette,
            groups: [
              {
                title: "User-Centric Design",
                text:
                  "Our UI/UX design approach is centered on users. Through research and analysis, we gain a deep understanding of user needs and business goals, translating insights into intuitive structures, clear navigation, and modern interface designs.",
              },
              {
                title: "Design Features",
                text:
                  "We create responsive interfaces, intuitive user flows, and accessible designs that meet modern usability standards. Consistent brand integration ensures a cohesive experience across all digital touchpoints.",
              },
            ],
          },
          {
            id: "cloud",
            title: "Cloud Computing",
            icon: FaCloud,
            groups: [
              {
                title: "Cloud Migration",
                text:
                  "We support organizations in migrating their systems to the cloud using Infrastructure as a Service (IaaS), Platform as a Service (PaaS), and Software as a Service (SaaS). Our solutions provide flexible, secure, and future-ready cloud infrastructures.",
              },
              {
                title: "Cloud Features",
                text:
                  "Our cloud solutions offer scalable resources, automated backups for data protection, multi-cloud strategies for high availability, and advanced security measures to safeguard sensitive data and systems.",
              },
            ],
          },
        ],
      },

      {
        id: "ai-solutions",
        title: "New AI Solutions",
        services: [
          {
            id: "ai-solutions",
            title: "AI Solutions",
            icon: FaBrain,
            groups: [
              {
                title: "Software Solutions Powered by AI",
                text:
                  "We develop intelligent software solutions powered by artificial intelligence to automate and optimize business processes. These include machine learning models for predictive analytics, natural language processing for intelligent interactions, and computer vision technologies for image and video analysis.",
              },
              {
                title: "AI Software Features",
                text:
                  "Our AI-driven solutions are tailored to your business requirements. They integrate seamlessly through APIs, process data near real-time, and are built on scalable architectures designed to grow with your organization.",
              },
            ],
          },
          {
            id: "process-optimization-ai",
            title: "Process Optimization Powered by AI",
            icon: FaCogs,
            groups: [
              {
                title: "Workflow Optimization",
                text:
                  "By applying artificial intelligence to workflow analysis, we automatically identify inefficiencies and optimization opportunities. Intelligent process automation, predictive analytics, and continuous monitoring enable sustainable performance improvements.",
              },
              {
                title: "Optimization Features",
                text:
                  "Our solutions detect bottlenecks early, optimize resource utilization, and provide actionable performance analytics. Automated reporting ensures transparency and supports data-driven decision-making.",
              },
            ],
          },
          {
            id: "data-visualization-ai",
            title: "Data Visualization Using Embedded AI",
            icon: FaChartLine,
            groups: [
              {
                title: "AI-Driven Data Visualization",
                text:
                  "We build intelligent data visualization solutions that automatically analyze and present data. Dynamic dashboards are generated based on data patterns and deliver meaningful insights in near real-time.",
              },
              {
                title: "Visualization Features",
                text:
                  "Our visualization platforms support natural language queries, automatic anomaly detection, and intelligent drill-down capabilities. Personalized dashboards adapt to user behavior and analytical needs.",
              },
            ],
          },
        ],
      },

      {
        id: "consultation",
        title: "New Consultation Services",
        services: [
          {
            id: "consultation-services",
            title: "Consultation Services",
            icon: FaUsers,
            groups: [
              {
                title: "Gap Identification",
                text:
                  "We provide specialized consultation services to identify gaps in existing business processes and systems. Through systematic analysis, benchmarking against industry standards, and measurable efficiency assessments, we uncover concrete improvement opportunities.",
              },
              {
                title: "Project Management",
                text:
                  "Our project management services ensure structured planning, efficient resource allocation, and realistic timelines. By applying agile methodologies and proactive risk management, we deliver projects transparently and successfully.",
              },
              {
                title: "Efficiency Optimization",
                text:
                  "Through in-depth process understanding and targeted gap analysis, we help organizations optimize workflows, reduce costs, and sustainably improve overall efficiency.",
              },
            ],
          },
        ],
      },
    ],
  },
};